export enum CustomerFlow {
  Base = 'base',
  CarTrip = 'carTrip',
  FlightOnlyFromMarketplace = 'flightOnlyFromMarketplace',
  FlightHotelFromMarketplace = 'flightHotelFromMarketplace',
  HotelOnlyFromMarketplace = 'hotelOnlyFromMarketplace',
  InfiniteLoadReload = 'infiniteLoadReload',
  MetaHotel = 'metaHotel',
  HotelSelectionForCountryFromMarketplace = 'hotelSelectionForCountryFromMarketplace',
  HotelUpsell = 'hotelUpsell',
}
